import * as React from "react";
import { styled } from "@mui/system";
import MUICardMedia from "@mui/material/CardMedia";
import {
  CardMediaProps as CardMediaPropsMUI,
  CardMediaTypeMap
} from "@mui/material/CardMedia";
export interface CardMediaProps extends CardMediaPropsMUI {
  component?: React.ElementType;
  alt?: string;
  height?: string | number;
  width?: string | number;
}

const CardMediaRoot = styled(MUICardMedia, {
  name: "CardMedia",
  slot: "Root",
  overridesResolver: (props, styles) => [styles.root]
})(({ theme }) => ({}));

export const CardMedia = React.forwardRef<HTMLDivElement, CardMediaProps>(
  function CardMedia(props, ref) {
    return <CardMediaRoot {...props} ref={ref} />;
  }
) as React.FC<CardMediaProps>;
